import React from "react";
import { Application, ApplicationQuickMetrics } from "../../..";
import AppSummaryGridItemContainer from "./Items/AppSummaryGridItemContainer";
import { LoadingState } from "../../../../Common";

type Props = {
  apps: Application[];
  appMetrics: Record<string, ApplicationQuickMetrics>;
  appMetricsLoadingState: LoadingState;
};

export default class AppSummaryGrid extends React.Component<Props> {
  render() {
    return (
      <>
        {this.props.apps.map(el => {
          const thisItemMetrics = this.props.appMetrics[el.rolePrefix];

          return (
            <AppSummaryGridItemContainer
              app={el}
              key={el.authId}
              metrics={thisItemMetrics}
              loadingState={this.props.appMetricsLoadingState}
            />
          );
        })}
      </>
    );
  }
}
